import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TypeFODIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21 5C21 3.89543 20.1046 3 19 3L15 3C13.8954 3 13 3.89543 13 5V7C13 9.20914 14.7909 11 17 11H19C20.1046 11 21 10.1046 21 9V5ZM5 3C3.89543 3 3 3.89543 3 5V9C3 10.1046 3.89543 11 5 11H7C9.20914 11 11 9.20914 11 7V5C11 3.89543 10.1046 3 9 3H5ZM21 19C21 20.1046 20.1046 21 19 21H15C13.8954 21 13 20.1046 13 19V17C13 14.7909 14.7909 13 17 13H19C20.1046 13 21 13.8954 21 15V19ZM3 19C3 20.1046 3.89543 21 5 21H9C10.1046 21 11 20.1046 11 19V17C11 14.7909 9.20914 13 7 13H5C3.89543 13 3 13.8954 3 15L3 19Z'
                fill='currentColor'
            />
        </>
    ),
})

TypeFODIcon.displayName = 'TypeFODIcon'
